import { render, staticRenderFns } from "./Dpi.vue?vue&type=template&id=41bacc9f"
import script from "./Dpi.vue?vue&type=script&lang=js"
export * from "./Dpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports